export const Environments = ['prod', 'at', 'dev', 'local'] as const;
export type Environment = (typeof Environments)[number];
export type RuntimeEnvironment = Environment | 'local-apim';

export type AppContext =
  // The current URLs (altibox.net/snartibox.net)
  | 'current'
  // For running a local instance of TV Studio
  | 'local';

export const appUrlMap: Record<AppContext, Partial<Record<Environment, string>>> = {
  local: {
    prod: 'http://localhost:3001',
    at: 'http://localhost:3000',
    dev: 'http://localhost:3002',
    local: 'http://localhost:3003',
  },

  current: {
    prod: 'https://tvstudio.ats.az.altibox.net',
    at: 'https://tvstudio.ats.at.az.snartibox.net',
    dev: 'https://tvstudio.ats.dev.az.snartibox.net',
  },
};
